import { BigDataObjectConstants } from "./constants/big-data-object-constants";
import { BigDataHelper } from "./helpers/big-data-helper";
import { DeviceInformationHelper } from "./helpers/device-information-helper";
import { CollectionIdsObject, CtaObject, RegistrationWallObject, Utils } from "./utils/utils";

export class BigData {
    static sendDataOceanEvent(eventId: string, attributes: any) {
        const dataOceanEvent = {
            e: eventId,
            a: attributes
        };

        if (window["DataOcean"] && window["DataOcean"].userEventCache) {
            window["DataOcean"].userEventCache.push(dataOceanEvent);
        }
    }

    static prepareDataOceanAttribute(dataCta: CtaObject, dataId: CollectionIdsObject, dataRW: RegistrationWallObject = {}, clickID: string = ""): object {
        const guid = BigDataHelper.getBigDataGUID(),
            pageViewId = BigDataHelper.getBigDataOrCookieValue(
                BigDataObjectConstants.pageViewCookie,
                BigDataObjectConstants.pageViewBigData
            ),
            visitId = BigDataHelper.getBigDataOrCookieValue(
                BigDataObjectConstants.visitIdCookie,
                BigDataObjectConstants.visitIdBigData
            ),
            externalId = BigData.getHashedEmail(),
            clickObj = clickID.length ? { clickID } : {},
            dataOceanAttribute = Object.assign({
                visitId,
                pageViewId,
                guid,
            }, dataId, dataCta, dataRW, externalId, clickObj);

        return dataOceanAttribute;
    }

    static getHashedEmail() {
        var dmParams = window["domain_marketing_params"];

        if (dmParams && dmParams.hashedEmail && dmParams.hashedEmail.length) {
            return { externalId: dmParams.hashedEmail };
        } else {
            return {};
        }
    }

    static prepareBlackList(): Array<ItemBlackListDto> {
        const objectId = "1001",
            homePageId = 0,
            articleId: number | undefined = Utils.attributeToNumber(DeviceInformationHelper.getXX()),
            blackList = [
                {
                    definitionOuterId: homePageId,
                    objectId
                }
            ];

        if (articleId) {
            blackList.push(
                {
                    definitionOuterId: articleId,
                    objectId
                }
            );
        }

        return blackList;
    }

    static prepareRequestDto(widgetId: string, params: ParamsDto | undefined): RequestDto {
        const data: RequestDto = {
            blackList: BigData.prepareBlackList(),
            widgetId,
            userIds: {
                guid: BigDataHelper.getBigDataGUID(),
                gwemid: BigDataHelper.getBigDataGWEMID(),
                gwguid: BigDataHelper.getBigDataGWGUID()
            },
        };

        return params ? Object.assign(data, { params }) : data;
    }

    static async getRecommendations(widgetId: string, params?: ParamsDto): Promise<Array<RecommendationDto>> {
        const response = await fetch('https://recommendation.wyborcza.pl/recommendations/v1/bigdata/widget?localTopicDayResponse', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(BigData.prepareRequestDto(widgetId, params))
        });

        return await response.json();
    }
}

export interface RecommendationDto {
    id: number;
    lead: string;
    params: ParamsDto;
    photoUrl: string;
    publicationDate: string;
    example: string;
    salesProductId: string;
    signature: string;
    title: string;
    url: string;
}

export interface ItemBlackListDto {
    definitionOuterId: number;
    objectId: string;
}

export interface ParamsDto {
    [key: string]: string;
}

export interface RequestDto {
    params?: ParamsDto;
    blackList: Array<ItemBlackListDto>;
    widgetId: string;
    userIds: {
        guid: string | null;
        gwemid: string;
        gwguid: string;
    }
}